import * as Sentry from "@sentry/react";

export const initSentry = () => {
  // Only initialize Sentry in production
  if (import.meta.env.PROD) {
    Sentry.init({
      // User's actual Sentry DSN
      dsn: "https://9c3573eead1910bc706c88b4177516f5@o4509547628003328.ingest.us.sentry.io/4509547634163712",

      integrations: [
        Sentry.browserTracingIntegration({
          // Set tracing origins to localhost, your domain, and Firebase
          tracePropagationTargets: [
            "localhost",
            /^https:\/\/yourapp\.web\.app/,
            /^https:\/\/.*\.firebaseapp\.com/,
            /^https:\/\/.*\.cloudfunctions\.net/,
          ],
        }),
      ],

      // Performance Monitoring
      tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring

      // Release tracking
      release: import.meta.env.VITE_APP_VERSION || "1.0.0",

      // Environment
      environment: import.meta.env.VITE_ENVIRONMENT || "production",

      // User context
      beforeSend(event) {
        // Filter out development errors
        if (event.exception) {
          const error = event.exception.values[0];
          if (
            error.value &&
            error.value.includes("ResizeObserver loop limit exceeded")
          ) {
            return null; // Don't send this common harmless error
          }
        }
        return event;
      },

      // Additional options
      attachStacktrace: true,
      debug: false, // Set to true for debugging Sentry itself

      // Privacy settings - you can set this to true if you want IP addresses
      sendDefaultPii: true, // Matches your preference
    });
  }

  // Make test function available globally in development
  if (import.meta.env.DEV) {
    window.testSentry = testSentry;
    console.log(
      "Sentry initialized! Type 'testSentry()' in console to test error reporting"
    );
  }
};

// Helper function to set user context
export const setSentryUser = (user) => {
  Sentry.setUser({
    id: user.uid,
    email: user.email,
    username: user.displayName,
  });
};

// Helper function to add breadcrumbs for user actions
export const addSentryBreadcrumb = (
  message,
  category = "user",
  level = "info"
) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    timestamp: Date.now() / 1000,
  });
};

// Helper function to capture custom errors
export const captureError = (error, context = {}) => {
  Sentry.withScope((scope) => {
    Object.keys(context).forEach((key) => {
      scope.setTag(key, context[key]);
    });
    Sentry.captureException(error);
  });
};

// Helper function to test Sentry (for development/testing only)
export const testSentry = () => {
  if (import.meta.env.DEV) {
    console.log("Testing Sentry error capture...");
    try {
      throw new Error("Test error from Pet AI ID - Sentry is working!");
    } catch (error) {
      Sentry.captureException(error);
      console.log("Test error sent to Sentry");
    }
  }
};

export default Sentry;
